import { rankWith,RankedTester,optionIs, schemaTypeIs, isArrayObjectControl, isObjectArrayControl, or, isPrimitiveArrayControl, isControl, and } from '@jsonforms/core';
export const rankTester = (widgetName:string):RankedTester=>{
  return rankWith(200, optionIs("widget",widgetName));
}

export const rankArrayTester: RankedTester = rankWith(
  300,
  or(isObjectArrayControl, isPrimitiveArrayControl)
);

export default rankTester;